/**
 * Network Connectivity Hook - Web Version
 * Uses browser's online/offline events
 */

import { useEffect, useState } from 'react';

export function useNetworkConnectivity() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return {
    isOnline,
    isConnecting: false, // Web doesn't have a connecting state
  };
}
